<template>
  <v-container class="mt-12">

    <!-- 🎁 Donation Progress Card -->
    <v-card class="mb-8">
      <v-card-title class="justify-center text-h4">🎁 تقدم التبرع</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-sheet class="pa-4 text-center" elevation="1">
              <div class="text-subtitle-1">المبلغ المراد جمعه</div>
              <div class="text-h6 font-weight-bold">{{ donation.target_amount  }} ريال</div>
            </v-sheet>
          </v-col>
          <v-col cols="6">
            <v-sheet class="pa-4 text-center" elevation="1">
              <div class="text-subtitle-1">المبلغ الذي تم جمعه حتي الان</div>
              <div class="text-h6 font-weight-bold">{{ donation.collected_amount  }} ريال</div>
            </v-sheet>
          </v-col>
        </v-row>

        <!-- Progress Bar -->
        <v-progress-linear
          class="my-4"
          v-model="progressBar"
          color="green"
          height="16"
          rounded
        ></v-progress-linear>

        <!-- Update Form -->
        <v-form @submit.prevent="updateDonation">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.target_amount"
                label="🎯 المبلغ المراد جمعه"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.collected_amount"
                label="💰 المبلغ الذي تم جمعه حتي الان"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn color="green" dark type="submit">💾 حفظ</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>


      <div class="card-container">
      <h2 class="card-title">📊 إحصائيات المدفوعات</h2>

      <!-- Filters -->
      <div class="card-text">
        <div class="filters">
          <label>نوع التقرير:</label>
          <select v-model="statsType" class="select-box">
            <option value="daily">يومي</option>
            <option value="monthly">شهري</option>
            <option value="yearly">سنوي</option>
          </select>

          <label>من تاريخ:</label>
          <input type="date" v-model="fromDate" class="input-box" />

          <label>إلى تاريخ:</label>
          <input type="date" v-model="toDate" class="input-box" />

          <button class="action-button yellow-button" @click="fetchStats">
            عرض النتائج
          </button>
        </div>

        <!-- Chart -->
        <div style="max-width: 100%; margin-top: 20px;">
          <canvas id="statsChart"></canvas>
        </div>
      </div>
    </div>

    

    <!-- 📝 Orders List -->


<!-- <template> -->
  <div class="card-container">
    <h2 class="card-title">📜 مدفوعات التبرعات</h2>

    <div class="card-text">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <!-- Loop through headers to create table headings -->
              <th v-for="header in headers" :key="header.key" class="text-left" :style="{ width: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through orders to create table rows -->
            <tr v-for="item in orders" :key="item._id">
              <!-- Donor Info Column -->
              <td>{{ item.donor.name }} | {{ item.donor.phone_number }}</td>
              <!-- Amount Column -->
              <td>{{ item.amount }} ريال</td>
              <!-- Payment Status Column with custom span for styling -->
              <td>
                <span
                  :style="{
                    backgroundColor: getStatusColor(item.paymentStatus),
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    display: 'inline-block'
                  }"
                >
                  {{ getStatusNameAr(item.paymentStatus) }}
                </span>
              </td>
              <!-- Created At Column with date formatting -->
              <td>{{ new Date(item.createdAt).toLocaleString() }}</td>
              <!-- Actions Column with a native button -->
              <td>
                <!-- <button
                  v-if="item.paymentStatus === 'pending'"
                  @click="resendPayment(item._id)"
                  class="action-button yellow-button"
                >
                  Resend Payment
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
<!-- </template> -->

  </v-container>
</template>
<script>
import repository from '@/api/repository';
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  BarController   
} from 'chart.js';

Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, BarController   );

export default {
  data() {
    return {
      donation: { target_amount: 0, collected_amount: 0 },
      form: { target_amount: 0, collected_amount: 0 },
      orders: [],
      stats: [],
      statsType: 'daily',
      fromDate: '',
      toDate: '',
      chart: null,
      headers: [
        { title: 'معلومات المتبرع', key: 'donor', value: 'donor', sortable: false, width: '25%' },
        { title: 'المبلغ', key: 'amount', value: 'amount', width: '15%' },
        { title: 'حالة الدفع', key: 'paymentStatus', value: 'paymentStatus', width: '20%' },
        { title: 'تم الانشاء في', key: 'createdAt', value: 'createdAt', width: '25%' },
      ],
    };
  },
  computed: {
    progressBar() {
      if (!this.donation.target_amount) return 0;

      console.log({
        progressBar:  Math.min(
        100,
        (this.donation.collected_amount / this.donation.target_amount) * 100
      ).toFixed(0)
      })
      return Math.min(
        1000,
        (this.donation.collected_amount / this.donation.target_amount) * 100
      ).toFixed(0);
    },
  },
  async created() {
    await this.fetchDonation();
    await this.fetchOrders();
    await this.fetchStats();
  },
   beforeUnmount() {
    // cleanup when leaving component
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    async fetchDonation() {
      const res = await repository.index('donations');
      this.donation = res.data;
      this.form = { ...res.data };

      this.donation.collected_amount /= 1000;
      this.donation.target_amount /= 1000;

      this.form.collected_amount /= 1000;
      this.form.target_amount /= 1000;
    },
    async updateDonation() {
      let data = {...this.form};
      data.collected_amount *= 1000;
      data.target_amount *= 1000;

      const res = await repository.updateOne('donations', data);
      this.donation = res.data;
       this.donation.collected_amount /= 1000;
      this.donation.target_amount /= 1000;
      alert("Donation updated!");
    },
    async fetchOrders() {
      try {
        const res = await repository.index('donation-payments');

        console.log({res})
        this.orders = res.data.data;
        console.log({orders: this.orders})

      } catch (err) {
        console.error(err);
      }
    },
    async resendPayment(orderId) {
      try {

        await repository.resend('donation-payments', orderId);

        alert("Payment link resent!");
        this.fetchOrders();
      } catch (err) {
        console.error(err);
        alert("Failed to resend payment");
      }
    },
     getStatusColor(status) {
    switch (status) {
      case 'paid':
        return 'green';
      case 'pending':
        return 'orange';
      case 'failed':
        return 'red';
      case 'refunded':
        return 'blue';
      default:
        return 'grey';
    }
  },
   getStatusNameAr(status) {
    switch (status) {
      case 'paid':
        return 'تم الدفع';
      case 'pending':
        return 'قيد الانتظار';
      case 'failed':
        return 'فشل';
      case 'refunded':
        return 'تم الاسترداد';
      default:
        return 'معلقة';
    }
  },

   async fetchStats() {
      try {
        const res = await repository.indexParams('donation-payments/stats', {
          
            type: this.statsType,
            fromDate: this.fromDate,
            toDate: this.toDate
          
        });
        this.stats = res.data.data;
        this.renderChart();
      } catch (err) {
        console.error(err);
      }
    },

    // Format date depending on type
    formatDate(id) {
      if (id.day) return `${id.year}-${id.month}-${id.day}`;
      if (id.month) return `${id.year}-${id.month}`;
      return `${id.year}`;
    },
    renderChart() {
      const labels = this.stats.map(item => this.formatDate(item._id));
      const amounts = this.stats.map(item => item.totalAmount);

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = document.getElementById('statsChart');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'إجمالي المبالغ (ريال)',
              data: amounts,
              backgroundColor: '#4CAF50'
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: true, position: 'bottom' }
          }
        }
      });
    }
  },
};
</script>

<style scoped>

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f9fafb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.filter-group {
  display: flex;
  flex-direction: column;
  min-width: 150px;
  flex: 1;
}

.filter-group label {
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.filter-select,
.filter-input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.95rem;
  outline: none;
  transition: border-color 0.2s ease;
}

.filter-select:focus,
.filter-input:focus {
  border-color: #4caf50;
}

.action-button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.yellow-button {
  background-color: #fbbc04;
  color: #000;
}

.yellow-button:hover {
  background-color: #e6a800;
}

@media (max-width: 600px) {
  .filters {
    flex-direction: column;
    align-items: stretch;
  }
}

/* Basic styling for the native HTML elements */
.card-container {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin: 20px;
  background-color: #fff;
  overflow: hidden; /* Ensures borders/shadows are contained */
}

.card-title {
  font-size: 1.5rem;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  color: #333;
  display: flex;
  align-items: center;
}

.card-title .v-icon { /* Adjust if you decide to keep Vuetify icons */
  margin-right: 8px;
}

.card-text {
  padding: 16px 24px;
}

.table-container {
  max-height: 300px; /* Adjusted height to make scrollbar more apparent */
  overflow-y: auto; /* Adds scrollbar if content exceeds height */
  border: 1px solid #eee; /* Light border around the scrollable area */
  border-radius: 4px;
}

.data-table {
  width: 100%;
  border-collapse: collapse; /* Collapses borders between cells */
  table-layout: fixed; /* Ensures column widths are respected */
}

.data-table th,
.data-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #eee; /* Separator for rows */
  word-wrap: break-word; /* Prevents long text from overflowing */
}

.data-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #555;
  position: sticky; /* Makes headers sticky on scroll */
  top: 0;
  z-index: 1; /* Ensures header stays above scrolling content */
}

.data-table tr:hover {
  background-color: #f9f9f9; /* Subtle hover effect */
}

.text-left {
  text-align: left;
}

.action-button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: background-color 0.2s ease-in-out;
  color: #fff; /* Default text color for buttons */
}

.action-button:hover {
  opacity: 0.9;
}

.yellow-button {
  background-color: #FBBC04; /* Google Yellow, similar to yellow-darken-2 */
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .card-container {
    margin: 10px;
  }
  .card-title {
    font-size: 1.25rem;
    padding: 12px 16px;
  }
  .data-table th,
  .data-table td {
    padding: 8px 10px;
    font-size: 0.9rem;
  }
  .action-button {
    font-size: 0.75rem;
    padding: 6px 10px;
  }
}
</style>
